"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDataModule = void 0;
var error_helper_const_1 = require("@const/error-handling/error-helper.const");
var helper_const_1 = require("@const/helper.const");
var object_service_1 = require("@services/object-service");
var translation_1 = __importDefault(require("@services/translation"));
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = require("lodash");
var mappings_const_1 = require("../const/mappings.const");
var data_processing_service_1 = require("../services/data-processing.service");
var fitpos_api_middleware_service_1 = require("../services/fitpos-api-middleware.service");
var ChangeDataModule = /** @class */ (function () {
    function ChangeDataModule() {
        this.fitposAPIMiddleware = object_service_1.ObjectService.getInstance(fitpos_api_middleware_service_1.FitposAPIMiddleware);
        this.dataProcessing = object_service_1.ObjectService.getInstance(data_processing_service_1.DataProcessing);
    }
    ChangeDataModule.prototype.loadModule = function (customer, moduleDiv) {
        return __awaiter(this, void 0, void 0, function () {
            var _ActionMapping;
            var _this = this;
            return __generator(this, function (_a) {
                if (customer) {
                    _ActionMapping = {
                        submit: function () { return _this.submitInputs(customer); },
                    };
                    // fill data
                    this.dataProcessing.fillDataGet(moduleDiv, customer);
                    // confirm button
                    this.dataProcessing.mapDataAction(moduleDiv, _ActionMapping);
                    //input validation
                    (0, cash_dom_1.default)(moduleDiv)
                        .find('input[data-set]')
                        .on('change', { helper: {} }, function (event) {
                        return _this.checkInputAndToggleError(event.target);
                    });
                }
                else {
                    // TODO behaviour if customer couldn't be retrieved
                }
                return [2 /*return*/];
            });
        });
    };
    // returns false if input doesn't match regex, if no regex is found it returns true
    // also adds error field to input
    ChangeDataModule.prototype.checkInputAndToggleError = function (input) {
        var key = (0, cash_dom_1.default)(input).attr('data-set');
        if (key === 'dateOfBirth' && /^\d{2}\/\d{2}\/\d{4}$/.test(input.value)) {
            var _a = input.value.split('/'), day = _a[0], month = _a[1], year = _a[2];
            input.value = "".concat(year, "-").concat(month, "-").concat(day);
        }
        var validation = (0, lodash_1.get)(mappings_const_1._DataSetValidation, key);
        if (validation) {
            if (validation.regex.test(input.value)) {
                (0, error_helper_const_1._RemoveAllStatusFlagsFromObject)((0, cash_dom_1.default)('#' + input.id));
                return true;
            }
            else {
                (0, error_helper_const_1._AddErrorToDomObject)((0, cash_dom_1.default)('#' + input.id), validation.regexError);
                (0, error_helper_const_1._ScrollToFirstErrorField)((0, cash_dom_1.default)('body'));
                return false;
            }
        }
        return true;
    };
    ChangeDataModule.prototype.submitInputs = function (customer) {
        return __awaiter(this, void 0, void 0, function () {
            var validInput, updatedProperties, error_1;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        validInput = true;
                        updatedProperties = {};
                        (0, cash_dom_1.default)('input[data-set]').each(function (i, element) {
                            var newValue = element.value;
                            var key = element.getAttribute('data-set');
                            var value = (0, lodash_1.get)(customer, key);
                            // if (!value) {
                            //   console.log(
                            //     "Property '" +
                            //       key +
                            //       "' does not exist. Available properties are:" +
                            //       Object.keys(customer).join(', ')
                            //   );
                            // }
                            if (!(0, cash_dom_1.default)(element).is("input[type='radio']:not(:checked)") &&
                                typeof newValue !== 'undefined' &&
                                newValue !== value) {
                                if (_this.checkInputAndToggleError(element)) {
                                    (0, lodash_1.set)(updatedProperties, key, newValue);
                                }
                                else {
                                    validInput = false;
                                }
                            }
                        });
                        if (!validInput) return [3 /*break*/, 7];
                        if (!((_a = Object.keys(updatedProperties)) === null || _a === void 0 ? void 0 : _a.length)) return [3 /*break*/, 5];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fitposAPIMiddleware.postAmendments(updatedProperties, customer)];
                    case 2:
                        _c.sent();
                        (0, error_helper_const_1._ShowSuccessMessageTimed)(translation_1.default.t(mappings_const_1._Messages.PostSuccess));
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        (0, generator_const_1._ShowErrorMessageTimed)(translation_1.default.t((_b = error_1.data.debugData.errorMessage) !== null && _b !== void 0 ? _b : mappings_const_1._Messages.PostError));
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        (0, helper_const_1._ScrollToTop)();
                        return [3 /*break*/, 6];
                    case 5:
                        (0, generator_const_1._ShowErrorMessageTimed)(translation_1.default.t('There are no changes to post'));
                        _c.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        console.error(translation_1.default.t('There are invalid inputs, cannot send amendment'));
                        _c.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return ChangeDataModule;
}());
exports.ChangeDataModule = ChangeDataModule;
// if (
//   $(MAPPINGS.iban.id).length &&
//   typeof ($(MAPPINGS.iban.id) as any).inputmask === 'function'
// ) {
//   ($(MAPPINGS.iban.id) as any).inputmask({
//     mask: 'AA99 9999 9999 9999 9999 99',
//     clearMaskOnLostFocus: false,
//   });
// }
// <script src="https://files.fittec.io/files/webflow/jquery.inputmask.bundle.js"></script>
